/*
 * McDonald's x Yellowpop teaser page.
 * Each section root has a data-mcdt attribute. The value selects the module below.
 * The sign-up form sends the data like the theme "ajax-form" forms (dynamic form section).
 */
(function () {
  'use strict';

  if (window.McdoTeaser) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Helpers ---------- */

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function readJSON(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  // Replaces [key] placeholders in a setting text.
  function fill(text, values) {
    return String(text || '').replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function scrollToTarget(href) {
    if (!href || href.charAt(0) !== '#') return false;
    var target = document.getElementById(href.slice(1));
    if (!target) return false;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    setTimeout(function () {
      var first = target.querySelector('input:not([type="hidden"])');
      if (first && first.offsetParent) first.focus({ preventScroll: true });
    }, 600);
    return true;
  }

  // Phone formats (mobile numbers, without the national trunk prefix):
  // country, prefix, pattern, minimum digits, maximum digits, example, trunk prefix ('' = none).
  // The 27 EU countries and the UK, then the other countries.
  var COUNTRIES = [
    ['AT', '+43', '### #######', 10, 11, '664 1234567', '0'],
    ['BE', '+32', '### ## ## ##', 9, 9, '470 12 34 56', '0'],
    ['BG', '+359', '## ### ####', 8, 9, '87 123 4567', '0'],
    ['HR', '+385', '## ### ####', 8, 9, '91 234 5678', '0'],
    ['CY', '+357', '## ######', 8, 8, '96 123456', ''],
    ['CZ', '+420', '### ### ###', 9, 9, '601 123 456', ''],
    ['DK', '+45', '## ## ## ##', 8, 8, '32 12 34 56', ''],
    ['EE', '+372', '#### ####', 7, 8, '5123 4567', ''],
    ['FI', '+358', '## ### ####', 8, 10, '41 234 5678', '0'],
    ['FR', '+33', '# ## ## ## ##', 9, 9, '6 12 34 56 78', '0'],
    ['DE', '+49', '#### #######', 10, 11, '1512 3456789', '0'],
    ['GR', '+30', '### ### ####', 10, 10, '691 234 5678', ''],
    ['HU', '+36', '## ### ####', 9, 9, '20 123 4567', '06'],
    ['IE', '+353', '## ### ####', 9, 9, '85 012 3456', '0'],
    ['IT', '+39', '### ### ####', 9, 10, '312 345 6789', ''],
    ['LV', '+371', '## ### ###', 8, 8, '21 234 567', ''],
    ['LT', '+370', '### #####', 8, 8, '612 34567', '0'],
    ['LU', '+352', '### ### ###', 9, 9, '628 123 456', ''],
    ['MT', '+356', '#### ####', 8, 8, '9696 1234', ''],
    ['NL', '+31', '# ########', 9, 9, '6 12345678', '0'],
    ['PL', '+48', '### ### ###', 9, 9, '512 345 678', ''],
    ['PT', '+351', '### ### ###', 9, 9, '912 345 678', ''],
    ['RO', '+40', '### ### ###', 9, 9, '712 034 567', '0'],
    ['SK', '+421', '### ### ###', 9, 9, '912 123 456', '0'],
    ['SI', '+386', '## ### ###', 8, 8, '31 234 567', '0'],
    ['ES', '+34', '### ## ## ##', 9, 9, '612 34 56 78', ''],
    ['SE', '+46', '## ### ## ##', 9, 9, '70 123 45 67', '0'],
    ['GB', '+44', '#### ######', 10, 10, '7400 123456', '0'],
    ['CH', '+41', '## ### ## ##', 9, 9, '78 123 45 67', '0'],
    ['US', '+1', '(###) ###-####', 10, 10, '(201) 555-0123', '1'],
    ['CA', '+1', '(###) ###-####', 10, 10, '(506) 234-5678', '1'],
    ['BR', '+55', '(##) #####-####', 11, 11, '(11) 96123-4567', ''],
    ['MX', '+52', '## #### ####', 10, 10, '55 1234 5678', ''],
    ['AU', '+61', '### ### ###', 9, 9, '412 345 678', '0'],
    ['JP', '+81', '##-####-####', 10, 10, '90-1234-5678', '0']
  ];

  // Keeps only the national number: removes a typed or pasted international
  // prefix (+33, 0033) and the national trunk prefix (the 0 in 06 12 34 56 78).
  function nationalDigits(raw, c) {
    var digits = String(raw || '').replace(/\D/g, '');
    var cc = c[1].replace(/\D/g, '');
    var international = /^\s*\+/.test(raw) || digits.indexOf('00') === 0;
    if (digits.indexOf('00') === 0) digits = digits.slice(2);
    if ((international || digits.length > c[4]) && digits.indexOf(cc) === 0) digits = digits.slice(cc.length);
    if (c[6] && digits.indexOf(c[6]) === 0) digits = digits.slice(c[6].length);
    return digits.slice(0, c[4]);
  }

  /* ---------- Modules ---------- */

  var modules = {};

  // Sign-up: countdown, phone format, checks, submission and the printed ticket.
  // The form copies the Dynamic Form section and the theme ajax-form handler (bundle.js AjaxForm).
  modules.signup = function (root) {
    var cfg = readJSON(root, '[data-signup-config]');
    var form = root.querySelector('[data-signup-form]');
    var errorEl = root.querySelector('[data-form-error]');
    var cta = root.querySelector('[data-signup-cta]');
    var phoneRow = root.querySelector('[data-phone-row]');
    var ccSel = phoneRow && phoneRow.querySelector('[data-phone-cc]');
    var phoneIn = phoneRow && phoneRow.querySelector('[data-phone-input]');
    var phoneValue = phoneRow && phoneRow.querySelector('[data-phone-value]');
    var hintEl = phoneRow && phoneRow.querySelector('[data-phone-hint]');
    var timers = [];
    var busy = false;
    var done = false;

    function show(key, on) {
      toArray(root.querySelectorAll('[data-if="' + key + '"]')).forEach(function (el) {
        el.hidden = !on;
      });
    }

    /* Countdown */
    var launch = Date.parse(root.getAttribute('data-launch') || '');
    var cdLabel = root.querySelector('[data-cd-label]');
    var units = toArray(root.querySelectorAll('[data-u]'));
    function tick() {
      if (isNaN(launch)) return;
      var left = Math.max(0, launch - Date.now());
      var d = Math.floor(left / 864e5); left -= d * 864e5;
      var h = Math.floor(left / 36e5); left -= h * 36e5;
      var m = Math.floor(left / 6e4); left -= m * 6e4;
      var s = Math.floor(left / 1e3);
      var values = { d: d, h: h, m: m, s: s };
      units.forEach(function (el) {
        el.textContent = pad(values[el.getAttribute('data-u')]);
      });
      if (cdLabel && launch <= Date.now() && cfg.liveLabel) cdLabel.textContent = cfg.liveLabel;
    }
    tick();
    var clock = setInterval(tick, 1000);

    /* Phone format (country block) */
    function current() {
      return ccSel ? COUNTRIES[+ccSel.value] : null;
    }
    function format(digits, pattern) {
      var out = '';
      var j = 0;
      for (var i = 0; i < pattern.length && j < digits.length; i++) {
        out += pattern[i] === '#' ? digits[j++] : pattern[i];
      }
      return out + digits.slice(j);
    }
    function phoneValues(c) {
      return { example: c[5], digits: c[3] === c[4] ? String(c[4]) : c[3] + ' à ' + c[4], country: c[0] + ' ' + c[1] };
    }
    function refreshPhone() {
      var c = current();
      if (!c) return;
      var digits = nationalDigits(phoneIn.value, c);
      phoneIn.value = digits ? format(digits, c[2]) : '';
      phoneIn.placeholder = c[5];
      phoneValue.value = digits ? c[1] + digits : '';
      if (hintEl) hintEl.textContent = fill(phoneRow.getAttribute('data-hint'), phoneValues(c));
    }
    if (ccSel && phoneIn) {
      var defaultCountry = phoneRow.getAttribute('data-default-country') || 'FR';
      COUNTRIES.forEach(function (c, i) {
        var opt = document.createElement('option');
        opt.value = i;
        opt.textContent = c[0] + ' ' + c[1];
        if (c[0] === defaultCountry) opt.selected = true;
        ccSel.appendChild(opt);
      });
      phoneIn.addEventListener('input', refreshPhone);
      ccSel.addEventListener('change', function () {
        refreshPhone();
        phoneIn.focus();
      });
      refreshPhone();
    }

    /* Checks: every field block with data-check. */
    var fields = toArray(form.querySelectorAll('[data-check]'));
    function check() {
      var errors = [];
      var first = null;
      fields.forEach(function (el) {
        var type = el.getAttribute('data-check');
        var required = el.hasAttribute('required') || el.getAttribute('data-required') === 'true';
        var bad = false;
        var message = el.getAttribute('data-error');
        var focusEl = el;

        if (type === 'phone') {
          var c = current();
          var digits = nationalDigits(phoneIn.value, c);
          bad = (required && !digits) || (digits && (digits.length < c[3] || digits.length > c[4]));
          message = fill(message, phoneValues(c));
          focusEl = phoneIn;
        } else if (type === 'checkbox') {
          bad = required && !el.checked;
        } else {
          var value = el.value.trim();
          if (required && !value) bad = true;
          if (!bad && value && type === 'email') bad = !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
          if (!bad && value && type === 'number') bad = isNaN(Number(value));
        }

        if (bad) {
          el.setAttribute('aria-invalid', 'true');
          if (message) errors.push(message);
          if (!first) first = focusEl;
        } else {
          el.removeAttribute('aria-invalid');
        }
      });
      errorEl.textContent = errors.join(' ');
      return { ok: !first, first: first };
    }

    fields.forEach(function (el) {
      el.addEventListener('input', function () {
        el.removeAttribute('aria-invalid');
      });
    });

    /* Submission: the same request as the theme ajax-form handler. */
    function send() {
      var body = new FormData(form);
      var hubspot = getCookie('hubspotutk');
      if (hubspot) body.append('hubspotutk', hubspot);

      return fetch(form.getAttribute('action'), { method: form.getAttribute('method') || 'post', body: body, redirect: 'follow' }).then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (json) {
            if (!res.ok) throw new Error((json && json.message) || 'HTTP ' + res.status);
            return json;
          });
      });
    }

    function ticketName() {
      var el = cfg.ticketField ? form.querySelector('[name="' + cfg.ticketField + '"]') : null;
      return el ? el.value.trim() : '';
    }

    function printTicket(name) {
      var orderNo = '#' + String(Math.floor(100 + Math.random() * 9900)).padStart(4, '0');
      toArray(root.querySelectorAll('[data-order-no], [data-order-no-big]')).forEach(function (el) {
        el.textContent = orderNo;
      });
      var ticket = root.querySelector('[data-ticket]');
      var printer = root.querySelector('[data-printer]');
      if (!ticket) return;
      root.querySelector('[data-ticket-name]').textContent = name;
      ticket.setAttribute('aria-hidden', 'false');
      if (printer) printer.classList.add('busy');
      ticket.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      timers.push(setTimeout(function () {
        ticket.classList.add('printed');
        timers.push(setTimeout(function () {
          if (printer) printer.classList.remove('busy');
          ticket.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
        }, 1650));
      }, reduceMotion ? 0 : 450));
    }

    function signup() {
      if (done || busy) return;
      var r = check();
      if (!r.ok) {
        r.first.focus();
        return;
      }
      busy = true;
      var label = cta.innerHTML;
      var name = ticketName();
      var formName = form.getAttribute('data-name');
      var successEvent = form.getAttribute('data-success-event');
      cta.classList.add('busy');
      cta.textContent = cfg.busyLabel;

      send().then(
        function (json) {
          busy = false;
          cta.classList.remove('busy');
          errorEl.textContent = '';
          // Same events as the theme ajax-form handler.
          if (successEvent) window.dispatchEvent(new CustomEvent(successEvent, { detail: json }));
          if (form.getAttribute('data-success') === 'true') {
            done = true;
            window.dispatchEvent(new CustomEvent('form:success', { detail: json }));
            show('showForm', false);
            cta.disabled = true;
            cta.textContent = cfg.doneLabel;
          } else {
            cta.innerHTML = label;
          }
          form.reset();
          refreshPhone();
          show('submitted', true);
          if (window.track && formName) {
            try {
              window.track({ event: 'formSubmission', eventCategory: 'form', eventAction: 'subscription', eventLabel: formName, event_name: 'collaboration_form' });
            } catch (e) {
              /* Tracking must not stop the sign-up. */
            }
          }
          printTicket(name);
          document.dispatchEvent(new CustomEvent('mcdt:signedup'));
        },
        function () {
          busy = false;
          cta.classList.remove('busy');
          cta.innerHTML = label;
          errorEl.textContent = cfg.errServer;
        }
      );
    }

    // The button is outside the form, so the form submit and the button both call signup().
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      signup();
    });
    cta.addEventListener('click', function (e) {
      e.preventDefault();
      signup();
    });

    return {
      destroy: function () {
        clearInterval(clock);
        timers.forEach(clearTimeout);
      }
    };
  };

  // Film: plays the video, or shows a message when there is no video.
  modules.film = function (root) {
    var player = root.querySelector('[data-film-player]');
    var play = root.querySelector('[data-film-play]');
    var template = root.querySelector('[data-film-template]');
    var pending = root.querySelector('[data-film-pending]');
    if (!player || !play) return null;

    play.addEventListener('click', function () {
      if (!template) {
        if (pending) pending.hidden = false;
        return;
      }
      player.innerHTML = '';
      player.appendChild(template.content.cloneNode(true));
      var video = player.querySelector('video');
      if (video && video.play) {
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      }
    });
    return null;
  };

  // Sticky bar: shows after the given scroll, hides after the sign-up or when closed.
  modules.sticky = function (root) {
    var threshold = (parseInt(root.getAttribute('data-threshold'), 10) || 0) / 100;
    var closed = false;
    var signed = false;

    function setBar(on) {
      if (on) {
        root.hidden = false;
        requestAnimationFrame(function () {
          root.classList.add('show');
        });
        document.body.classList.add('has-bar');
        document.body.style.setProperty('--bar-h', root.offsetHeight + 'px');
      } else {
        root.classList.remove('show');
        document.body.classList.remove('has-bar');
      }
    }

    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var past = max > 0 && window.scrollY >= max * threshold;
      setBar(past && !closed && !signed);
    }

    function onSigned() {
      signed = true;
      setBar(false);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('mcdt:signedup', onSigned);
    root.querySelector('[data-sticky-close]').addEventListener('click', function () {
      closed = true;
      setBar(false);
    });
    root.querySelector('[data-sticky-cta]').addEventListener('click', function (e) {
      if (scrollToTarget(root.getAttribute('data-target'))) e.preventDefault();
    });
    onScroll();

    return {
      destroy: function () {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        document.removeEventListener('mcdt:signedup', onSigned);
        document.body.classList.remove('has-bar');
      }
    };
  };

  /* ---------- Start and theme editor events ---------- */

  // Anchor buttons (for example "Get early access") scroll to the form and select the name field.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-scroll-signup]');
    if (link && scrollToTarget(link.getAttribute('href'))) e.preventDefault();
  });

  function instancesIn(scope) {
    var list = toArray(scope.querySelectorAll('[data-mcdt]'));
    return list.filter(function (el) {
      return el.__mcdt;
    }).map(function (el) {
      return el.__mcdt;
    });
  }

  function initAll(scope) {
    toArray((scope || document).querySelectorAll('[data-mcdt]')).forEach(function (el) {
      if (el.__mcdt) return;
      var mod = modules[el.getAttribute('data-mcdt')];
      if (!mod) return;
      el.__mcdt = mod(el) || {};
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    instancesIn(e.target).forEach(function (inst) {
      if (inst.destroy) inst.destroy();
    });
  });

  window.McdoTeaser = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();